export default __webpack_public_path__ + "../ckeditor/plugins/specialchar/dialogs/lang/tr.js";